import { call } from "redux-saga/effects";
import { takeLatest } from "redux-saga/effects";
import { API_URL, SAGA_ACTIONS, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

function* revenueAnalytics(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.ANALYTICS.REVENUE, action.payload, true);
}

function* subscriptionAnalytics(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.ANALYTICS.SUBSCRIPTION, action.payload, true);
}

function* growthAnalytics(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.ANALYTICS.GROWTH, action.payload, true);
}

function* funnelAnalytics(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.ANALYTICS.FUNNEL, action.payload, true);
}

function* meetingsAnalytics(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.ANALYTICS.MEETINGS, action.payload, true);
}

function* performanceAnalytics(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.ANALYTICS.PERFORMANCE, action.payload, true);
}

function* aiUsageAnalytics(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.ANALYTICS.AI_USAGE, action.payload, true);
}

function* adminInvoices(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.ANALYTICS.INVOICES, action.payload, true);
}

function* getSalesNotes(action: any): any {
  const companyId = action.payload?.company_id;
  yield call(sagaFunction, action, CallApi.GET, API_URL.SALES_NOTES.GET(companyId), {}, true);
}

function* createSalesNote(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.SALES_NOTES.CREATE, action.payload, true);
}

function* updateSalesNote(action: any): any {
  const noteId = action.payload?.note_id;
  const { note_id, ...payload } = action.payload;
  yield call(sagaFunction, action, CallApi.PUT, API_URL.SALES_NOTES.UPDATE(noteId), payload, true);
}

function* deleteSalesNote(action: any): any {
  const noteId = action.payload?.note_id;
  yield call(sagaFunction, action, CallApi.DELETE, API_URL.SALES_NOTES.DELETE(noteId), {}, true);
}

export default function* adminAnalyticsSaga() {
  yield takeLatest(SAGA_ACTIONS.ADMIN.ANALYTICS.REVENUE, revenueAnalytics);
  yield takeLatest(SAGA_ACTIONS.ADMIN.ANALYTICS.SUBSCRIPTION, subscriptionAnalytics);
  yield takeLatest(SAGA_ACTIONS.ADMIN.ANALYTICS.GROWTH, growthAnalytics);
  yield takeLatest(SAGA_ACTIONS.ADMIN.ANALYTICS.FUNNEL, funnelAnalytics);
  yield takeLatest(SAGA_ACTIONS.ADMIN.ANALYTICS.MEETINGS, meetingsAnalytics);
  yield takeLatest(SAGA_ACTIONS.ADMIN.ANALYTICS.PERFORMANCE, performanceAnalytics);
  yield takeLatest(SAGA_ACTIONS.ADMIN.ANALYTICS.AI_USAGE, aiUsageAnalytics);
  yield takeLatest(SAGA_ACTIONS.ADMIN.ANALYTICS.INVOICES, adminInvoices);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SALES_NOTES.GET, getSalesNotes);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SALES_NOTES.CREATE, createSalesNote);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SALES_NOTES.UPDATE, updateSalesNote);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SALES_NOTES.DELETE, deleteSalesNote);
}
